import { Paper, Tooltip, tooltipClasses, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { json } from "react-router-dom";
import { get, patch, post } from "../../../../apiClient";

export async function globalFloorsFetcher(params) {
  try {
    return await get("managed_plus", "/pricing/global_audience_floors", {
      params: { ...params },
    });
  } catch (error) {
    switch (error.status) {
      case 400:
      case 422: {
        return json(error.details, { status: error.status });
      }
      default:
        throw error;
    }
  }
}

export async function preview_floors_changes(params) {
  try {
    return await post(
      "managed_plus",
      "/pricing/preview_floors_changes/global",
      params
    );
  } catch (error) {
    switch (error.status) {
      case 400:
      case 422: {
        return json(error.details, { status: error.status });
      }
      default:
        throw error;
    }
  }
}

export async function update(params) {
  try {
    return await patch(
      "managed_plus",
      "/pricing/global_audience_floors",
      params
    );
  } catch (error) {
    switch (error.status) {
      case 400:
      case 422: {
        return json(error.details, { status: error.status });
      }
      default:
        throw error;
    }
  }
}

export const editPricingButtonStyle = {
  width: 112,
  height: 36,
  paddingLeft: 10,
  paddingRight: 10,
  backgroundColor: "rgba(25, 118, 210, 1)",
};

export const textFieldNormal = {
  width: 60,
  height: 38,
};

export const textFieldChanged = {
  width: 60,
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "rgba(25, 118, 210, 1)",
    },
    "&:hover fieldset": {
      borderColor: "rgba(25, 118, 210, 1)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "rgba(25, 118, 210, 1)",
    },
    "& input": {
      color: "rgba(25, 118, 210, 1)",
    },
    "& .MuiInputAdornment-root": {
      color: "rgba(25, 118, 210, 1)",
    },
  },
};

export const textFieldError = {
  width: 60,
  "& .MuiOutlinedInputRoot": {
    "& fieldset": {
      borderColor: "rgba(222, 0, 28, 1)",
    },
    "&:hover fieldset": {
      borderColor: "rgba(222, 0, 28, 1)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "rgba(222, 0, 28, 1)",
    },
    "& .MuiInputAdornment-root": {
      color: "rgba(222, 0, 28, 1)", // Set color of the InputAdornment (e.g., the dollar sign)
    },
  },
};

export const NoMaxWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} placement="top" />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "none",
  },
});

export const GlobalAudienceFloorsInstructions = () => {
  return (
    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Typography variant="h6">Instructions</Typography>
      <Typography
        variant="body2"
        sx={{ fontWeight: 500, color: "text.secondary", mb: 1 }}
      >
        Use this page to view and update default Managed+ Audience floors and
        Reserve Costs.
        <br />
        Note that the changes made here do not affect custom floors set for
        specific clients but will update the default rates for all clients
        without custom pricing
      </Typography>
      <Typography
        variant="body2"
        sx={{ fontWeight: 400, color: "text.secondary" }}
      >
        Enter required inputs below and click <b>‘Apply’</b> to view current
        default rates.
        <br />
        To modify rates, click <b>‘Update’</b> and adjust pricing variables,
        <br /> Click <b>‘Confirm’</b> to save changes or <b>‘Cancel’</b> to
        discard any changes.
      </Typography>
    </Paper>
  );
};

export const TableSpacing = () => {
  return (
    <tbody>
      <tr>
        <td>
          <br />
        </td>
      </tr>
    </tbody>
  );
};
